<!--  -->
<template>
  <div class="lingchuang-list">
    <div class="lingchuang-main">
      <div class="lingchuang-select">
        <ul class="lingchuang-ul">
          <li
            v-for="(item, index) in lingchuangList"
            :key="index"
            :class="{ active: item.cid == currentShow }"
            @click="changelingchuang(item.cid)"
          >
            <!-- <router-link :to="item.url"> -->
            <div class="lingchuang-logo">
              <img :src="item.src" />
            </div>
            <h1>{{ item.title }}</h1>
            <!-- </router-link> -->
          </li>
        </ul>
        <router-link to="#" v-show="ouzhouShow">
          <div
            class="clinic"
            @click="changelingchuang(linghang.cid)"
            :class="{ active: linghang.cid == currentShow }"
          >
            <div class="lingchuang-box">
              <img :src="linghang.pic_f" />
            </div>
            <h1>{{ linghang.title }}</h1>
          </div>
        </router-link>
      </div>

      <ul class="yingyong-list">
        <li
          class="yingyong-li"
          v-for="(item, index) in yingyongList"
          :key="index"
        >
          <div class="yingyong-photo">
            <img class="imgControl" :src="item.pic_f" />
          </div>
          <div class="yingyong-main">
            <div class="yingyong-time">
              <h1>{{ item.year }}</h1>
              <h2>{{ item.month }}</h2>
            </div>
            <div class="fenge"></div>
            <router-link :to="item.url" target="_blank" class="yingyong-text">
              <h1>{{ item.title }}</h1>
              <p>
                {{ item.msg }}
              </p>
            </router-link>
            <div class="look-more">
              <router-link :to="item.url" target="_blank">
                <div class="look">
                  <span>{{ lookmore }}</span>
                </div>
                <div class="more">></div>
              </router-link>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      gid: 0,
      lingchuangList: [
        /* 
        {
          title: "肺癌",
          src: require("../../assets/lingcuang1.png"),
        },
        {
          title: "COPD",
          src: require("../../assets/lingcuang2.png"),
        },
       */
      ],
      linghang: {
        cid: 0,
        title: "", //领航文库
        pic_f: "",
      },
      yingyongList: [
        /* 
        {
          time: "2020-01-08",
          year: "2020",
          month: "01-08",
          title:
            "Ballet®(芭蕾)腔静脉滤器在上海交通大学附属第六人民医院首例临床应用成功",
          msg: "2019年11月8日，一枚预防致死性肺栓塞的最新型下腔静脉滤器在上海交通大学附属第六人民医院血管外科成功置入一位下肢深静脉血栓患者的腔静脉内，并于体内存留56天、消除肺栓塞风险后成功取出。",
        },
        {
          time: "2021-02-24",
          year: "2021",
          month: "02-24",
          title:
            "DragonFly™经导管二尖瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统",
          msg: "2020年9月29日，在今年的世界心脏日当天，浙江大学医学院附属第二医院(浙二医院)王建安教授团队应用DragonFly™二尖瓣瓣膜夹...",
        },
        {
          time: "2021-02-24",
          year: "2021",
          month: "02-24",
          title:
            "DragonFly™经导管二尖瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统",
          msg: "2020年9月29日，在今年的世界心脏日当天，浙江大学医学院附属第二医院(浙二医院)王建安教授团队应用DragonFly™二尖瓣瓣膜夹...",
        },
        {
          time: "2021-02-24",
          year: "2021",
          month: "02-24",
          title:
            "DragonFly™经导管二尖瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统",
          msg: "2020年9月29日，在今年的世界心脏日当天，浙江大学医学院附属第二医院(浙二医院)王建安教授团队应用DragonFly™二尖瓣瓣膜夹...",
        },
        {
          time: "2021-02-24",
          year: "2021",
          month: "02-24",
          title:
            "DragonFly™经导管二尖瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统瓣瓣膜夹系统",
          msg: "2020年9月29日，在今年的世界心脏日当天，浙江大学医学院附属第二医院(浙二医院)王建安教授团队应用DragonFly™二尖瓣瓣膜夹...",
        },
       */
      ],
      lookmore: "", //查看更多
      currentShow: false,
      ouzhouShow: true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    changelingchuang(val) {
      const that = this;
      that.currentShow = val;
      if (val == "") {
      } else {
        $.ajax({
          url: "/index.php?s=Home/Api/get_data",
          type: "get",
          datatype: "json",
          data: {
            act: "article_list",
            category_id: val,
            xiaji: 1,
            product_id: that.gid,
          },
          success: function (ret) {
            var obj = JSON.parse(ret); //json数据转为数组
            if (obj.code == "0000") {
              that.yingyongList = [];
              $.each(obj.data, function (i, k) {
                that.yingyongList.push({
                  time: k.create_times,
                  year: k.year,
                  month: k.month + "-" + k.day,
                  title: k.title,
                  msg: k.description,
                  pic_f: k.pic_f,
                  url: "/patienparticulars?id=" + k.id,
                  // url: k.filepath,
                });
              });
            }
          },
          error: function (err) {
            console.log("ajax错误");
          },
        });
      }
    },
    //1.得到产品分类n+1
    get_class() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_two_class",
          id: 15,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            var lang = "";
            if (obj.lang) {
              lang = obj.lang;
            }
            if (obj.region == 2 || obj.region == 1) {
              that.ouzhouShow = false;
            } else {
              that.ouzhouShow = true;
            }
            $.each(obj.data, function (i, k) {
              if (i < obj.data.length - 1) {
                that.lingchuangList.push({
                  cid: k.id,
                  title: k.title,
                  src: k.pic_f,
                  url: k.url + lang,
                });
              } else if (i == obj.data.length);
              {
                that.linghang.cid = obj.data[i].id;
                that.linghang.title = obj.data[i].title;
                that.linghang.pic_f = obj.data[i].pic_f;
              }
            });

            if (obj.region == 1) {
              that.lingchuangList = [];
              that.linghang.cid = "";
              that.linghang.title = "";
              that.linghang.pic_f = "";
              $.each(obj.data, function (i, k) {
                that.lingchuangList.push({
                  cid: k.id,
                  title: k.title,
                  src: k.pic_f,
                  url: k.url + lang,
                });
              });
            } else if (obj.region == 2) {
              that.lingchuangList = [];
              that.linghang.cid = "";
              that.linghang.title = "";
              that.linghang.pic_f = "";
              $.each(obj.data, function (i, k) {
                that.lingchuangList.push({
                  cid: k.id,
                  title: k.title,
                  src: k.pic_f,
                  url: k.url + lang,
                });
              });
            }
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.lookmore = obj.data["ckgd"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var v = parseUrl();
    this.gid = v["gid"];
    this.get_class();
    this.get_fanyi();
    this.changelingchuang(15);
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};

function parseUrl() {
  var url = location.href;
  var i = url.indexOf("?");
  if (i == -1) return;
  var querystr = url.substr(i + 1);
  var arr1 = querystr.split("&");
  var arr2 = new Object();
  for (i in arr1) {
    var ta = arr1[i].split("=");
    arr2[ta[0]] = ta[1];
  }
  return arr2;
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.lingchuang-list {
  width: 100%;
  .lingchuang-main {
    width: $main-width;
    margin: 0 auto 120px;

    .lingchuang-select {
      display: flex;
      justify-content: space-between;
      .lingchuang-ul {
        display: flex;
        justify-content: space-between;
        li {
          width: 215px;
          height: 117px;
          background: #eeeeee;
          border-radius: 11px;
          padding: 14px;
          margin-right: 26px;
          cursor: pointer;
          transition: 0.3s;
          .lingchuang-logo {
            width: 100%;
            text-align: right;
          }
          h1 {
            margin-left: 10px;
            font-size: 1.2rem;
            color: #666;
          }
        }
        .active {
          background: #ffc85a;
          overflow: hidden;
          img {
            transform: translateY(-1350px);
            filter: drop-shadow(0px 1350px #fff);
          }
          h1 {
            color: #ffffff;
          }
        }
      }
      .clinic {
        width: 215px;
        height: 117px;
        background: #eeeeee;
        border-radius: 10px;
        padding: 15px 14px;
        .lingchuang-box {
          width: 100%;
          text-align: right;
        }
        h1 {
          font-size: 1.2rem;
          font-weight: bold;
          color: #666;
        }
      }
      .active {
        background: #ffc85a;
        overflow: hidden;
        img {
          transform: translateY(-1350px);
          filter: drop-shadow(0px 1350px #fff);
        }
        h1 {
          color: #ffffff;
        }
      }
    }

    .yingyong-list {
      width: 100%;
      .yingyong-li {
        margin-top: 50px;
        width: 100%;
        height: 200px;
        background: #ffffff;
        display: flex;
        justify-content: space-between;
        transition: 0.3s;
        .yingyong-photo {
          width: 24%;
          height: 100%;
        }
        .yingyong-main {
          width: 76%;
          display: flex;
          align-items: center;
          .yingyong-time {
            width: 10%;
            margin: 0 10px;
            text-align: center;
            h1 {
              font-size: 1.3rem;
              color: #666666;
            }
            h2 {
              font-size: 0.9rem;
            }
          }
          .fenge {
            width: 1px;
            height: 75px;
            background: #cccccc;
            margin-right: 20px;
          }
          .yingyong-text {
            margin: 0 20px;
            width: 62%;
            cursor: pointer;
            h1 {
              color: #333;
              font-size: 1.2rem;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              transition: 0.3s;
            }
            p {
              margin-top: 10px;
              color: #666;
              font-size: 1rem;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
          }
          .look-more {
            margin-left: 30px;
            a {
              width: 133px;
              height: 46px;
              background: #47aeea;
              display: flex;
              .look {
                width: 75%;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
              }
              .more {
                width: 25%;
                height: 46px;
                background: #f8ad17;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
              }
            }
          }
        }
      }
      .yingyong-li:hover {
        box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.1);
      }
      .yingyong-li:hover .yingyong-text h1 {
        color: #0069b5;
      }
    }
  }
}
@media screen and (max-width: $main-width) {
  .lingchuang-list {
    .lingchuang-main {
      width: 100%;
      .lingchuang-select {
        flex-wrap: wrap;
        .lingchuang-ul {
          width: 100%;
          flex-wrap: wrap;
          justify-content: center;
          li {
            margin: 10px auto;
            width: 90%;
          }
        }
        a {
          width: 100%;
          .clinic {
            width: 90%;
            margin: 10px auto;
          }
        }
      }
      .yingyong-list {
        .yingyong-li {
          padding: 0 10px;
          height: auto;
          flex-direction: column;
          justify-content: center;
          .yingyong-photo {
            width: 80%;
            margin: 0 auto;
          }
          .yingyong-main {
            border-top: 1px solid #cccccc;
            border-bottom: 1px solid #cccccc;
            width: 100%;
            flex-direction: column;
            .yingyong-time {
              width: 90%;
              margin: 10px auto;
              text-align: left;
            }
            .fenge {
              display: none;
            }
            .yingyong-text {
              width: 90%;
              margin: 10px auto;
              text-align: left;
            }
            .look-more {
              margin: 10px 0 10px 120px;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/LingchuangList.vue